import ModalComponent from '@components/common/Modal';
import OrderManagerApi from 'apis/api/OrderManager';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, message } from 'antd';
import { FaUpload } from 'react-icons/fa';
import { IoCloseCircleSharp } from 'react-icons/io5';
import ModalViewImages from './ModalViewImages';
import { CREATOR_IMAGE_FLAG, ORDER_IMAGE_KIND_LABEL, TOrderImageKind } from './orderImageUtils';

interface IOMConfig {
  isOpen: boolean;
  base64?: string;
  callBackClose?: () => any;
  callBackRefresh?: () => any;
  callBackCreate?: (data: any) => any;
  listHinh?: any;
  data?: any;
  status?: any;
  /** 'creator' thì gửi kèm CREATOR_IMAGE_FLAG để BE lưu vào CreatorImages */
  kind?: TOrderImageKind;
  /** chỉ xem: không xoá/thêm/sửa ghi chú, ẩn footer */
  readOnly?: boolean;
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
}

const isJpgOrPng = (f: File) => f.type === 'image/jpeg' || f.type === 'image/png';

// Lưới tự co giãn: mỗi ô tối thiểu 200px, màn hẹp còn 1 cột, màn rộng nhiều cột.
const GRID_CLASS = 'grid gap-3 grid-cols-[repeat(auto-fill,minmax(200px,1fr))]';
const CARD_CLASS = 'border rounded relative flex flex-col min-w-0 bg-white';
const IMG_BOX_CLASS = 'w-full h-[200px] flex items-center justify-center bg-gray-50';

export default function ModalUpdateImages(props: IOMConfig) {
  const { t } = useTranslation();
  const kind = props.kind ?? 'tech';
  const readOnly = !!props.readOnly || props.data?.data?.statusVNText === 'Hoàn tất';

  const inputRef = useRef<any>();
  const [listHinhNew, setListHinhNew] = useState<any[]>([]);
  // copy để xoá ảnh trong modal không làm đổi state của component cha khi bấm Huỷ
  const [listHinh, setListHinh] = useState<any[]>(() => [...(props.listHinh || [])]);
  const [valueListHinh, setValueListHinh] = useState<any[]>();
  const [valueListHinhNew, setValueListHinhNew] = useState<any[]>();
  const [images, setImages] = useState<any>(false);
  const [images1, setImages1] = useState<any>();
  const handleChangeValueHinh = (e, index) => {
    e.preventDefault();
    const value = e.target.value;
    setValueListHinh({
      ...valueListHinh,
      [index]: value
    });
  };
  const handleChangeValueHinhNew = (e, index) => {
    e.preventDefault();
    const value = e.target.value;
    setValueListHinhNew({
      ...valueListHinhNew,
      [index]: value
    });
  };

  const handleFormSubmit = async () => {
    const value = [];
    const valueHinh = [];
    for (let i = 0; i < listHinh.length; i++) {
      valueHinh.push({
        ...listHinh[i],
        id: listHinh[i].uid,
        base64: '',
        comment: valueListHinh ? valueListHinh[`${i}`] || listHinh[i].name : listHinh[i].name,
        name: valueListHinh ? valueListHinh[`${i}`] || listHinh[i].name : listHinh[i].name,
        context: props.data?.status
      });
    }

    for (let i = 0; i < listHinhNew.length; i++) {
      await getBase64(listHinhNew[i])
        .then((res: string) =>
          value.push({
            ...listHinhNew[i],
            id: 0,
            base64: res.replace(/^data:image\/[a-z]+;base64,/, ''),
            comment: valueListHinhNew ? valueListHinhNew[`${i}`] : '',
            context: props.data?.status
          })
        )
        .catch(err => console.log(err));
    }

    const dataBody = {
      maDonHang: props.data?.data?.maDonHang,
      listHinh: valueHinh,
      listHinhNew: value,
      ...(kind === 'creator' ? { [CREATOR_IMAGE_FLAG]: true } : {})
    };

    try {
      await OrderManagerApi.UploadImageOrder(dataBody).then(res => {
        if (!res.data.error) {
          message.success(t('StockManagement.ProductMix.Create.Success'));
          props.callBackRefresh();
          props.callBackClose();
        } else {
          if (res.data.messageCode == 'CODE_EXIST') message.error(t('System.ExistData'));
          else message.error(t('StockManagement.ProductMix.Create.Error'));
        }
      });
    } catch (error) {
      console.log(error);
      message.error(t('StockManagement.ProductMix.Create.Error'));
    }
  };
  const onChooseFile = () => {
    inputRef.current.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    const valid = files.filter(isJpgOrPng);
    if (valid.length < files.length) message.error('You can only upload JPG/PNG file!');
    if (valid.length) setListHinhNew(old => [...old, ...valid]);
    e.target.value = ''; // cho phép chọn lại đúng file vừa xoá
  };

  const handleDeleteImageListHinhNew = file => {
    setListHinhNew(old => old.filter(f => f !== file));
  };
  const handleDeleteImageListHinh = file => {
    setListHinh(old => old.filter(f => f !== file));
  };

  const isEmpty = listHinh.length === 0 && listHinhNew.length === 0;

  const removeButton = (onClick: () => void) =>
    readOnly ? null : (
      <button
        type="button"
        title="Xoá ảnh"
        className="absolute z-10 right-1 top-1 bg-white rounded-full leading-none"
        onClick={onClick}
      >
        <IoCloseCircleSharp color="red" size={22} />
      </button>
    );

  return (
    <ModalComponent
      modalTitle={`${t('Administrator.UploadImage.Title')} · ${ORDER_IMAGE_KIND_LABEL[kind]}`}
      modalType="confirm"
      modalSize="medium"
      visible={props.isOpen}
      onOk={handleFormSubmit}
      hiddenFooter={readOnly}
      okText="Lưu"
      okStyle="primary"
      onCancel={props.callBackClose}
    >
      {images && (
        <ModalViewImages
          callBackClose={() => setImages(false)}
          isOpen={images}
          images1={images1}
          listHinh={listHinh}
          callBackRefresh={() => console.log('call refresh')}
        />
      )}

      <input ref={inputRef} type="file" accept="image/png,image/jpeg" multiple onChange={handleFileChange} hidden />

      <div className="overflow-y-auto max-h-[75vh] pr-1">
        {readOnly && isEmpty && <div className="py-10 text-center text-gray-500">Không có hình ảnh</div>}

        <div className={GRID_CLASS}>
          {listHinh.map((e, index) => (
            <div className={CARD_CLASS} key={e.uid}>
              {removeButton(() => handleDeleteImageListHinh(e))}

              <div
                className={`${IMG_BOX_CLASS} cursor-pointer`}
                onClick={() => {
                  setImages1(e);
                  setImages(true);
                }}
              >
                <img className="max-w-full max-h-full object-contain" src={e.url} alt={e.name || ''} />
              </div>

              <div className="p-2 flex flex-col gap-1">
                <a
                  className="self-end text-blue-500 hover:underline text-[12px]"
                  href={e.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  Mở tab mới
                </a>
                <Input
                  disabled={readOnly}
                  onChange={ev => handleChangeValueHinh(ev, index)}
                  placeholder={t('Input.noteImages')}
                  defaultValue={e.name}
                />
              </div>
            </div>
          ))}

          {listHinhNew.map((e, index) => (
            <div className={CARD_CLASS} key={`${e.name}-${e.lastModified}-${index}`}>
              {removeButton(() => handleDeleteImageListHinhNew(e))}

              <div className={IMG_BOX_CLASS}>
                <img className="max-w-full max-h-full object-contain" src={URL.createObjectURL(e)} alt={e.name} />
              </div>

              <div className="p-2">
                <Input
                  disabled={readOnly}
                  onChange={ev => handleChangeValueHinhNew(ev, index)}
                  placeholder={t('Input.noteImages')}
                />
              </div>
            </div>
          ))}

          {!readOnly && (
            <button
              type="button"
              onClick={onChooseFile}
              className={`border-2 border-dashed rounded flex flex-col items-center justify-center gap-2 text-[#1890ff] hover:bg-blue-50 ${
                isEmpty ? 'min-h-[200px] col-span-full' : 'min-h-[200px]'
              }`}
            >
              <FaUpload size={isEmpty ? 56 : 40} />
              <span className="font-bold">Thêm hình ảnh</span>
            </button>
          )}
        </div>
      </div>
    </ModalComponent>
  );
}
